import styled from 'styled-components';

import { MEDIA_QUERIES } from "@constants";

export const DEIPageDatepickerDIV = styled.div`
  position: relative;
  width: calc(100vw - 50px);
  margin: 0 auto;

  @media (min-width: 445px) {
    width: 100%;
  }
`;

export const DEIPageDatepickerDatesDIV = styled.div`
  position: relative;
  width: 100%;
  max-width: 400px;
  margin-bottom: 30px;
  overflow: hidden;

  &::after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    width: 100%;
    background: linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 55.53%);;
    pointer-events: none;
  }

  > div {
    display: flex;
    flex-wrap: nowrap;
    transition: transform 0.3s;
  }

  ${MEDIA_QUERIES.M} {
    margin-bottom: 50px;
  }
`;

export const DEIPageDatepickerDateBUTTON = styled.button`
  display: inline-block;
  padding: 0 15px;
  margin-right: 20px;
  height: 38px;
  line-height: 35px;
  background: var(--color--charcoal-100);
  color: var(--color--charcoal-700);
  border-radius: 4px;
  white-space: nowrap;
  transition: all 0.3s;

  &:hover {
    background: var(--color--charcoal-200);
    color: var(--color--charcoal-700);
  }

  &:focus-visible {
    box-shadow: inset 0 0 0 2px var(--color--cobalt-600);
  }

  &.is-active {
    background: var(--color--charcoal-700);
    color: white;

    &:hover {
      background: var(--color--charcoal-800);
      color: white;
    }
  }
`;

export const DEIPageDatepickerBackBUTTON = styled.button`
  position: absolute;
  top: 0;
  left: -32px;
  width: 40px;
  height: 38px;
  opacity: 0;
  transition: opacity 0.3s;
  pointer-events: none;

  &.show {
    opacity: 1;
    pointer-events: all;
  }

  .Icon {
    background: var(--color--charcoal-600);
  }

  ${MEDIA_QUERIES.M} {
    left: -40px;
  }
`;
